import React from 'react'
import { Wrapper } from './StyledVyber'
import VyberSlider from './VyberSlider/VyberSlider'
import VyberArticle from './VyberArticle'
import VyberHeader from './VyberHeader'
import { getLinkTarget } from '../../utils/getLinkTarget'
import { sendCentrumVyberClick } from '../../utils/ga4Events'
import { DEVICES } from '../../../constants'

const CentrumVyber = (props) => {
  const {
    widget: {
      boxes,
      utmMedium,
      mainImageSize,
      sliderImageSize
    },
    activeDynamicLayout
  } = props

  const [firstBox, ...otherBoxes] = boxes

  const utmParams = {
    utmCampaign: firstBox.source,
    utmMedium
  }

  const target = getLinkTarget(activeDynamicLayout)

  const handleGaEvent = (event, { id, position, url, title }) => {
    event.preventDefault()

    sendCentrumVyberClick({
      id,
      position,
      url,
      title
    })

    if (activeDynamicLayout === DEVICES.DESKTOP) {
      window.open(url)
      return false
    } else {
      document.location.href = url
    }
  }

  return (
    <Wrapper>
      <VyberHeader target={target} utmParams={utmParams}/>
      <VyberArticle article={firstBox} utmParams={utmParams} imageSize={mainImageSize} handleGaEvent={handleGaEvent}/>
      <VyberSlider articles={otherBoxes} utmParams={utmParams} imageSize={sliderImageSize} handleGaEvent={handleGaEvent}/>
    </Wrapper>
  )
}

export default CentrumVyber
